import VerticalAlignBottomIcon from "@mui/icons-material/VerticalAlignBottom";

const VerticalAlignBottom = (props: any) => {
  return <VerticalAlignBottomIcon {...props} />;
};

export default VerticalAlignBottom;
